import { render, staticRenderFns } from "./FiWorkAssignmentSelector.vue?vue&type=template&id=25d1e730&"
import script from "./FiWorkAssignmentSelector.vue?vue&type=script&lang=js&"
export * from "./FiWorkAssignmentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports